import { useQuery } from '@tanstack/react-query';

import { fetchUsers } from '../api/usersApi';

export const ADMIN_USERS_QUERY_KEY = ['admin', 'users'] as const;

export function useAdminUsers() {
  return useQuery({
    queryKey: ADMIN_USERS_QUERY_KEY,
    queryFn: fetchUsers,
  });
}
